import React, { useEffect, useRef } from 'react';
import { Modal, Button } from 'antd';

import { TermsContent } from '../modules/privacy/terms';
import { DisclimerContent } from '../modules/privacy/disclaimer';

import '../styles/modules/project/termsModal.scss';

const STATEMENTS = {
  terms: {
    title: 'Terms of Use',
    Content: TermsContent,
  },
  disclaimer: {
    title: 'Project Disclaimer',
    Content: DisclimerContent,
  },
};

const StatementModal = ({ visible, statementKey, onClose }) => {
  const contentRef = useRef(null);
  const statement = STATEMENTS[statementKey];

  useEffect(() => {
    if (visible && contentRef.current) {
      contentRef.current.scroll({ top: 0, behavior: 'auto' });
    }
  }, [visible, statementKey]);

  if (!statement) {
    return null;
  }

  const { title, Content } = statement;

  return (
    <Modal
      wrapClassName="footer-statement-modal"
      title={title}
      centered
      closable
      maskClosable
      visible={visible}
      destroyOnClose
      zIndex={135}
      maskStyle={{
        background: 'rgba(0,0,0,0.7)',
      }}
      bodyStyle={{
        width: '42.5rem',
        maxHeight: '75vh',
        overflow: 'hidden',
      }}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
      onCancel={onClose}
    >
      <div className="privacy-p terms-content" ref={contentRef}>
        <Content />
      </div>
    </Modal>
  );
};

export default StatementModal;
